/**
 * Pure helpers for FRQ image-upload answer state.
 *
 * Extracted so the merge logic can be unit-tested independently of the React
 * component — particularly the race where an upload completes after the user
 * has already removed another image. The merge is correct as long as the
 * caller passes the LATEST answer_text JSON (read from a ref, not a captured
 * closure variable). See QuestionSlot.jsx for the ref-based read.
 */

/**
 * Append newly-uploaded URLs to the given part's image array in the latest
 * answer_text JSON, preserving any other state the user changed concurrently
 * (e.g., they removed a thumbnail or uploaded to a different part).
 *
 * @param {string} latestAnswerText - the current answer_text JSON string
 * @param {string} partLabel - e.g. "main", "a", "b.i"
 * @param {string[]} uploadedUrls - new public URLs to append
 * @returns {string} the merged answer_text JSON string
 */
export const mergeUploadedUrls = (latestAnswerText, partLabel, uploadedUrls) => {
    let latestObj = {};
    try { latestObj = latestAnswerText ? JSON.parse(latestAnswerText) : {}; } catch { /* keep latestObj as {} */ }
    const latestImages = Array.isArray(latestObj[partLabel]) ? latestObj[partLabel] : [];
    return JSON.stringify({ ...latestObj, [partLabel]: [...latestImages, ...uploadedUrls] });
};
